import { getSessionData } from "../../../utils/interceptors/localStorageService";

export const ULTIMATE_AGENT_PROFILE_KEY = "ultimate_agent_profile";
export const ULTIMATE_AGENT_ROLE_KEYS = ["LANDLORD", "AGENT", "TENANT"];

const normalizeRoles = (roles) => {
  const values = Array.isArray(roles) ? roles : [];
  return [...new Set(values
    .map((role) => (typeof role === "string" ? role : role?.key || role?.role))
    .map((role) => role?.toUpperCase())
    .filter((role) => ULTIMATE_AGENT_ROLE_KEYS.includes(role)))];
};

export const getUltimateAgentProfile = () => {
  const session = getSessionData();
  let storedProfile = null;

  try {
    storedProfile = JSON.parse(localStorage.getItem(ULTIMATE_AGENT_PROFILE_KEY));
  } catch (_) {
    storedProfile = null;
  }

  const sessionRoles =
    session?.ultimateAgentRoles || session?.ultimateAgentPersonas || session?.personas;
  const roles = normalizeRoles(storedProfile?.roles || sessionRoles);
  const availableRoles = roles.length ? roles : ["TENANT"];

  return {
    ...storedProfile,
    accountId:
      storedProfile?.accountId ||
      session?.ultimateAgentAccountId ||
      "UA-ETMFB-000284",
    roles: availableRoles,
    activeRole: availableRoles.includes(storedProfile?.activeRole)
      ? storedProfile.activeRole
      : availableRoles[0],
    registrationSource: storedProfile?.registrationSource || "existing-customer",
  };
};

export const saveUltimateAgentProfile = (profile) => {
  const fallbackProfile = getUltimateAgentProfile();
  const suppliedRoles = normalizeRoles(profile?.roles || profile?.personas);
  const roles = suppliedRoles.length ? suppliedRoles : fallbackProfile.roles;
  const suppliedActiveRole = typeof profile?.activeRole === "string"
    ? profile.activeRole.toUpperCase()
    : null;
  const nextProfile = {
    ...fallbackProfile,
    ...profile,
    roles,
    activeRole: roles.includes(suppliedActiveRole)
      ? suppliedActiveRole
      : roles[0] || "TENANT",
  };
  localStorage.setItem(ULTIMATE_AGENT_PROFILE_KEY, JSON.stringify(nextProfile));
  return nextProfile;
};
